import { useQuery } from '@tanstack/react-query';

import { ReferralProgramRequests } from '~/api/ReferralProgram';
import { userStore } from '~/stores';

const FIVE_MINUTES = 5 * 60 * 1000;

export const useRewardedPromocodes = (enabled = true) => {
  const userId = userStore.personalData.id;

  return useQuery({
    queryKey: ['rewardedPromocodes', userId],
    queryFn: () => ReferralProgramRequests.getCustomerRewards(userId as string),
    staleTime: FIVE_MINUTES,
    enabled: enabled && !!userId,
  });
};
